"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _layout = require("@berlitz/globals/lib/components/layout");
var _form = _interopRequireDefault(require("@berlitz/form"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _style = require("./style");
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var BlockForm = function BlockForm(_ref) {
  var action = _ref.action,
    afterForm = _ref.afterForm,
    backgroundColor = _ref.backgroundColor,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    enableReinitialize = _ref.enableReinitialize,
    fields = _ref.fields,
    formId = _ref.formId,
    hiddenFields = _ref.hiddenFields,
    lightText = _ref.lightText,
    locale = _ref.locale,
    method = _ref.method,
    onChange = _ref.onChange,
    onMount = _ref.onMount,
    onSubmit = _ref.onSubmit,
    size = _ref.size,
    submitLabel = _ref.submitLabel,
    subtitle = _ref.subtitle,
    termsLabel = _ref.termsLabel,
    title = _ref.title;
  (0, _react.useEffect)(function () {
    if (typeof onMount === 'function') onMount();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    id: formId || null,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, (title || subtitle) && /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 7
  }, /*#__PURE__*/_react.default.createElement(_style.FormTitleSpacer, {
    inverse: lightText
  }, /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: "center"
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, {
    "data-key": "max-form_title",
    inverse: lightText
  }, title), subtitle && _htmlCheck.default.test(subtitle) ? /*#__PURE__*/_react.default.createElement("div", {
    "data-key": "max-form_subtitle"
  }, /*#__PURE__*/_react.default.createElement(_typography.RichText, {
    inverse: lightText,
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  })) : /*#__PURE__*/_react.default.createElement(_typography.P, {
    "data-key": "max-form_subtitle",
    inverse: lightText
  }, subtitle))))), /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 9
  }, /*#__PURE__*/_react.default.createElement(_form.default, {
    action: action,
    enableReinitialize: enableReinitialize,
    fields: fields,
    hiddenFields: hiddenFields,
    light: lightText,
    method: method,
    onChange: onChange,
    onSubmit: onSubmit,
    submitLabel: submitLabel,
    termsLabel: termsLabel,
    locale: locale
  }), afterForm && afterForm))));
};
BlockForm.defaultProps = {
  backgroundColor: 'brandPrimary',
  lightText: true,
  size: 'xl',
  submitLabel: 'Submit'
};
var _default = BlockForm;
exports.default = _default;